import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem({
        id: 'subscriptions',
        label: 'Subscriptions',
        routerLink: ['/extensions/subscriptions'],
        // Icon can be any of https://core.clarity.design/foundation/icons/shapes/
        icon: 'repeat',
    }, 'sales'),
];